// 主题颜色处理
const style = localStorage.getItem('style') || 'atom';

const themeColor = {
    atomThemeColor :'#D46910',
    mcdThemeColor :'#D46910',
    yoplaitThemeColor :'#D46910'
}

const isMcd = style === 'mcd'? true: false // 是否为mcd主题

const AtomThemeColor = '#D46910';
const McdThemeColor = '#D46910';
const McdThemeColor2 = '#D46910';
const YoplaitThemeColor = '#D46910';

// 会员分类颜色
const myStrokeColor = {
    mcdStrokeColor: McdThemeColor2,
    atomStrokeColor: AtomThemeColor,
    yoplaitStrokeColor: YoplaitThemeColor
}
const strokeColor = myStrokeColor[style+'StrokeColor']

// 柱状图颜色
const myHistogramChartsColor = {
    mcdHistogramChartsColor: McdThemeColor2,
    atomHistogramChartsColor: AtomThemeColor,
    yoplaitHistogramChartsColor: YoplaitThemeColor
}
const HistogramChartsColor = myHistogramChartsColor[style+'HistogramChartsColor']

// 最常消费市场&城市 top4
const Top4Color = {
    mcdTop4Color: ["#906BFF", "#F1C40F", "#45D879", "#FF6B6B"],
    atomTop4Color: ["#2003FF", "#D46910", "#2E9600", "#6F1E17"],
    yoplaitTop4Color: ["#2003FF", "#D46910", "#2E9600", "#6F1E17"]
}
const HistogramTop4 =  Top4Color[style+'Top4Color']


// 购买时段偏好面积图
const myAreaColor = {
    mcdAreaColor: ['#FCD14D','#FCD14D'],
    atomAreaColor: ['#D46910','rgba(212, 105, 16, 0.02)'],
    yoplaitAreaColor: ['#D46910','rgba(212, 105, 16, 0.02)']
}
const AreaColor = myAreaColor[style+'AreaColor']

//  柱状图（数量）& 折线图（百分比）
const myColumnLineColor = {
    mcdColumnLineColor: {
        columnColor: '#FBBE02',
        lineColor: '#F84635'
    },
    atomColumnLineColor: {
        columnColor: '#D46910',
        lineColor: '#575757'
    },
    yoplaitColumnLineColor: {
        columnColor: '#D46910',
        lineColor: '#575757'
    }
}
const ColumnLineColor = myColumnLineColor[style+'ColumnLineColor']

// 分析比较面积图
const myMultiLineColor = {
    mcdMultiLineColor: {
        lineColor: ['rgb(255,248,122)', 'rgb(251, 190, 2)','rgb(237,109,0)'], //线颜色，折线上点的颜色
        areaStyleColor0: ['rgba(255,248,122, 0)','rgba(251, 190, 2, 0)','rgba(237,109,0, 0)'] ,// 面积0处颜色
        areaStyleColor1: ['rgb(255,248,122','rgb(251, 190, 2)','rgb(237,109,0)'] // 面积1处颜色
    },
    atomMultiLineColor: {
      lineColor: ['rgb(119, 11, 7)','rgb(212, 105, 16)','rgb(255, 200, 51)'],
      areaStyleColor0: ['rgba(119, 11, 7, 0)','rgba(212, 105, 16, 0)','rgba(255, 200, 51, 0)'],
      areaStyleColor1: ['rgb(119, 11, 7)','rgb(212, 105, 16)','rgb(255, 200, 51)']
    },
    yoplaitMultiLineColor: {
      lineColor: ['rgb(119, 11, 7)','rgb(212, 105, 16)','rgb(255, 200, 51)'],
      areaStyleColor0: ['rgba(119, 11, 7, 0)','rgba(212, 105, 16, 0)','rgba(255, 200, 51, 0)'],
      areaStyleColor1: ['rgb(119, 11, 7)','rgb(212, 105, 16)','rgb(255, 200, 51)']
    },
}
const MultiLineColor = myMultiLineColor[style+'MultiLineColor']

// 分析比较柱状图
const myMultiHistogramColor = {
    mcdMultiHistogramColor: {
        lineColor: ['rgb(255,248,122)', 'rgb(251, 190, 2)','rgb(237,109,0)'] //线颜色，折线上点的颜色
    },
    atomMultiHistogramColor: {
        lineColor: [ '#910500', '#D46910','#FFC833']
    },
    yoplaitMultiHistogramColor: {
        lineColor: [ '#910500', '#D46910','#FFC833']
    },
}
const MultiHistogramColor = myMultiHistogramColor[style+'MultiHistogramColor']

// footer 文字
const mcdFooterCopyright = 'Copyright © ATOM INTELLIGENCE';
const atomFooterCopyright = 'Copyright © ATOM INTELLIGENCE';
const yoplaitFooterCopyright = 'Copyright © ATOM INTELLIGENCE';
const footerCopyright = {
    mcdFooterCopyright,
    atomFooterCopyright,
    yoplaitFooterCopyright
}

export {
    strokeColor,
    HistogramChartsColor,
    footerCopyright,
    isMcd,
    McdThemeColor,
    AtomThemeColor,
    HistogramTop4,
    AreaColor,
    ColumnLineColor,
    themeColor,
    MultiLineColor,
    MultiHistogramColor
}
